export const FLOAT = "float";
export const INT = "int";
export const LIST = "list";
export const MASS_G = "mass_g";
export const MASS_KG = "mass_kg";
export const STRING = "string";
export const VOL_ML = "vol_ml";
export const VOL_L = "vol_l";
export const DENSITY = "density";
export const BOOLEAN = "bool";
export const TABLE = "table";
export const DATE = "date";
export const DATETIME = "datetime";
